/* eslint-disable react-hooks/exhaustive-deps */
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, TextField } from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import useApi, { httpClient } from "../../hooks/useApi";
import Constants from "../../utils/Constants";
import MESSAGES from "../../utils/Messages";

// バリデーション定義
const schema = z.object({
  id: z.string(),
  teamName: z
    .string()
    .min(1, MESSAGES.REQUIRED)
    .max(
      Constants.ONE_LINE_TEXT_MAX,
      MESSAGES.TEXT_MAX_ERROR(Constants.ONE_LINE_TEXT_MAX)
    ),
  mail: z
    .string()
    .min(1, MESSAGES.REQUIRED)
    .max(
      Constants.ONE_LINE_TEXT_MAX,
      MESSAGES.TEXT_MAX_ERROR(Constants.ONE_LINE_TEXT_MAX)
    )
    .email(MESSAGES.EMAIL_ERROR),
});

const TeamForm = ({ targetData = {}, closeHandler }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onBlur",
    resolver: zodResolver(schema),
  });
  const { connect } = useApi();

  // 新規作成時にフォームをクリア
  useEffect(() => {
    Object.keys(targetData).length !== 0
      ? reset({ ...targetData })
      : reset({
          id: "",
          teamName: "",
          mail: "",
        });
  }, [targetData]);

  // API POST
  const onSubmit = async (data) => {
    const result = await connect(() => {
      return httpClient.post("../api/mscsadmin/UpsertAuditTeam", data);
    }, "保存しました");
    console.log("post end", data); //TODO:開発用
    closeHandler(result);
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="teamName"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              label="チーム名"
              required
              {...field}
              error={!!errors.teamName}
              helperText={errors.teamName ? errors.teamName.message : ""}
            />
          )}
        />
        <br />
        <Controller
          name="mail"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              label="メールアドレス"
              required
              {...field}
              error={!!errors.mail}
              helperText={errors.mail ? errors.mail.message : ""}
            />
          )}
        />
        <br />
        <Button type="submit" disabled={isSubmitting}>
          保存
        </Button>
      </form>
    </>
  );
};

export default TeamForm;
